import React from "react";
import { Link } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// styles
import styles from "./Blogs.module.css";

// images
import calenderIcon from "../../../assets/img/HomePage/BlogCalenderIcon.svg";
import arrowIcon from "../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const BlogsSlider = props => {
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  return (
    <>
      <style type="text/css">
        {`
       .swiper {
        width: 100%;
      }
      .swiper-pagination {
        bottom: 0 !important;
      }

      .swiper-wrapper {
        ${props.blogsData?.length <= 2 ? `justify-content: space-around` : `justify-content: space-between`}
      }

      .swiper-pagination-bullet {
    border-radius: 0 !important;
      }

        `}
      </style>
      <Swiper
        className="mySwiper"
        style={{ height: "485px" }}
        // slidesPerView={3}
        // spaceBetween={0}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
        loop={true}>
        {props.blogsData?.map(item => (
          <SwiperSlide key={item.id}>
            <Link
              to={{
                pathname: `/وبلاگ/${item.slug}`,
                state: item,
              }}>
              <div dir="rtl" className={`d-flex align-items-center flex-column px-2 py-2 mt-3 mb-4 text-end ${styles.blog_card_container}`}>
                <Link
                  to={{
                    pathname: `/وبلاگ/${item.slug}`,
                    state: item,
                  }}
                  className="w-100 position-relative mb-3">
                  <img
                    className={styles.card_img}
                    loading="lazy"
                    src={`https://backdev.azrmelk.com/magAssets/img/Articles/${item.imageName}`}
                    alt={item.title}
                  />
                </Link>
                <h3 className={`w-100 d-flex justify-content-start px-2 mb-2 ${styles.card_title}`}>{item.title}</h3>
                <div className="w-100 d-flex justify-content-start px-2 my-2">
                  <img className="ms-2" src={calenderIcon} alt="icon" />
                  <div className={styles.title2}>{e2p(item.dateRelease)}</div>
                </div>
                <button className={`w-100 d-flex justify-content-end px-2 my-2 ${styles.read_btn}`}>
                  <div className={styles.text_primary}>بیشتر بخوانید</div>
                  <img className="me-2" src={arrowIcon} alt="icon" />
                </button>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default BlogsSlider;
